export default "__VITE_ASSET__C87VuMd7__"